module.exports = __webpack_public_path__ + "img/half5.dddaaff.png";